const kgToLb = (kg: number): number => {
  return Math.floor(kg * 2.20462);
};

export default kgToLb;
